export interface FirebaseRuntimeConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  appCheckSiteKey: string;
}

export function firebaseRuntimeRequested(): boolean {
  return import.meta.env.VITE_LADYBUG_RUNTIME === "firebase";
}

export function readFirebaseRuntimeConfig(): FirebaseRuntimeConfig {
  const config = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY?.trim() ?? "",
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN?.trim() ?? "",
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID?.trim() ?? "",
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET?.trim() ?? "",
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID?.trim() ?? "",
    appId: import.meta.env.VITE_FIREBASE_APP_ID?.trim() ?? "",
    appCheckSiteKey: import.meta.env.VITE_FIREBASE_APPCHECK_SITE_KEY?.trim() ?? ""
  };
  for (const [name, value] of Object.entries(config)) {
    if (value.length === 0) throw new Error(`${name} must be configured for the Firebase Ladybug runtime.`);
  }
  return config;
}
